import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

// Available color schemes
const COLOR_SCHEMES = ['neon', 'ocean', 'ember'];

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'dark';
  });

  const [colorScheme, setColorScheme] = useState(() => {
    return localStorage.getItem('colorScheme') || 'neon';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-scheme', colorScheme);
    localStorage.setItem('colorScheme', colorScheme);
  }, [colorScheme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const cycleColorScheme = () => {
    setColorScheme(prev => {
      const idx = COLOR_SCHEMES.indexOf(prev);
      return COLOR_SCHEMES[(idx + 1) % COLOR_SCHEMES.length];
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colorScheme, setColorScheme, cycleColorScheme, COLOR_SCHEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
